import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'login',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/AuthPageContainer'),
  }),
};
